import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const SCHEDULE_SCHEMA = Object.freeze({
  NEXT_RUN_DATE: null, // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ)
  INTERVAL: null, // DocumentScheduleIntervalEnum
  INVOICE_ID: '',
});
const RECORD = generateSchema(SCHEDULE_SCHEMA);
const KEYS: any = generateKeys(SCHEDULE_SCHEMA);

export class Schedule extends Record(RECORD) {
  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get nextRunDate(): string {
    return this.get(KEYS.NEXT_RUN_DATE);
  }

  get interval(): string {
    return this.get(KEYS.INTERVAL);
  }

  get invoiceId(): string {
    return this.get(KEYS.INVOICE_ID);
  }
}
